import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useAuthorizedAxios } from '../../../core/hooks';
import { isValidCustomerId } from '../../../customers';
import { ItsmNetworkServiceIncidentApiModel } from '../../../itsm/model';
import { getDashboardItsmNetworkServiceIncidents } from '../../api';
import { DashboardHttpQueryConfig } from '../../config';

export const useDashboardItsmNetworkServiceIncidents = (customerId: number | null): UseQueryResult<ItsmNetworkServiceIncidentApiModel[] | null, Error> => {
  const axios = useAuthorizedAxios();
  return useQuery({
    queryKey: [DashboardHttpQueryConfig['GetItsmNetworkServiceIncidents'].key, customerId],
    queryFn: async () => {
      if (customerId === null) {
        return null;
      } else {
        return await getDashboardItsmNetworkServiceIncidents(axios, { customerId });
      }
    },
    enabled: isValidCustomerId(customerId),
    gcTime: 5000,
    staleTime: 0,
    structuralSharing: false
  });
};